module.exports = __webpack_public_path__ + "img/device.6a3fd95a.svg";